import { render } from "./Popover.vue?vue&type=template&id=0edb61de"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"

import "./Popover.vue?vue&type=style&index=0&id=0edb61de&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__